import { configureStore } from '@reduxjs/toolkit'
import { updateModalSlice } from "./update-modal/updateModalSlice";
import { intlSlice } from './intl/intlSlice'
import { themeSlice } from './theme/themeSlice'

export const store = configureStore({
    reducer: {
        updateModal: updateModalSlice.reducer,
        intl: intlSlice.reducer,
        theme: themeSlice.reducer,
    },
    //关闭序列化检测
    middleware: (getDefaultMiddleware) =>
        getDefaultMiddleware({
            serializableCheck: false,
        }),
});

// Infer the `RootState` and `AppDispatch` types from the store itself
export type RootState = ReturnType<typeof store.getState>
// Inferred type: {posts: PostsState, comments: CommentsState, users: UsersState}
export type AppDispatch = typeof store.dispatch
